<template>
  <div>
    <Header></Header>
    <div class="main">
      <div class="main-cont">
        <div class="topbg"></div>
        <div class="title">
          <div class="t-left fl">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <!-- <el-tab-pane label="主页" name="first"></el-tab-pane> -->
              <el-tab-pane label="动态" name="second"></el-tab-pane>
              <!-- <el-tab-pane label="收藏" name="third"></el-tab-pane>
              <el-tab-pane label="订阅" name="fourth"></el-tab-pane> -->
            </el-tabs>
          </div>
          <div class="t-right fr">
            <div class="fl right-word">
              <span class="word">关注数</span><br />{{ me.followers }}
            </div>
            <div class="fl right-word">
              <span class="word">粉丝数</span><br />{{ me.befollowers }}
            </div>
            <div class="fl right-word">
              <span class="word">获赞数</span><br />{{ me.likenum }}
            </div>
            <div class="fl right-word">
              <span class="word">播放数</span><br />{{ me.playcount }}
            </div>
          </div>
          <div style="clear: both"></div>
        </div>
        <el-divider></el-divider>
        <div style="clear: both"></div>
      </div>

      <div class="content">
        <el-row :gutter="10">
          <el-col :span="16" v-for="(item, index) in playerList" :key="index">
            <el-card :body-style="{ padding: '8px' }" shadow="hover">
              <div class="cont-left">
                <a :href="'/userdetail?id=' + item.uid" target="_blank">
                  <el-avatar :size="sizeList[1]" :src="circleUrl"></el-avatar>
                </a>
              </div>
              <div class="cont-right">
                <h3>{{ item.userName }}</h3>
                <span style="color: #99a2aa; font-size: 13px">{{
                  dateFormat(item.createdate)
                }}</span>
                <br />
                <br />
                <a :href="'/video?id=' + item.id + '&uid=' + item.uid">
                  <img :src="GLOBAL.baseURL + item.cover" />
                </a>
                <div style="margin-top: 8px">
                  <a href="javascript:;" @click="clickLikeBtn(item.id)"
                    ><span
                      v-if="item.likestate == 0"
                      class="icon iconfont icon-like"
                    ></span>
                    <span
                      v-if="item.likestate == 1"
                      class="icon iconfont icon-liked"
                    ></span
                    ><span class="readnum2">{{ item.likenum }}</span></a
                  >
                  <!-- <a href="javascript:;"
                    ><span class="icon iconfont icon-shoucang"></span>
                    <a href="javascript:;" class="readnum2">{{item.commnum}}</a></a
                  > -->
                  <!-- <a href="javascript:;"><i class="el-icon-star-off"></i><span>{{}}</span></a>
               -->
                  <a :href="'/video?id=' + item.id + '&uid=' + item.uid"
                    ><i class="el-icon-chat-square"></i
                    ><span class="ml">{{ item.commnum }}</span></a
                  >
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
        <!--文章列表-->
        <el-row :gutter="10">
          <el-col :span="16" v-for="(item, index) in articleList" :key="index">
            <el-card :body-style="{ padding: '16px' }" shadow="hover">
              <div>
                <h3>{{ item.title }}</h3>
                <div class="desc-container">
                  <div class="desc online">{{ item.desc }}</div>
                </div>
                <span style="color: #99a2aa; font-size: 13px">{{
                  dateFormat(item.createTime)
                }}</span>
                <br />
                <br />
                <div style="margin-top: 8px">
                  <a href="javascript:;" @click="clickLikeBtn(item.id)"
                    ><span
                      v-if="item.likestate == 0"
                      class="icon iconfont icon-like"
                    ></span>
                    <span
                      v-if="item.likestate == 1"
                      class="icon iconfont icon-liked"
                    ></span
                    ><span class="readnum2">{{ item.likenum }}</span></a
                  >
                  <!-- <a href="javascript:;"
                    ><span class="icon iconfont icon-shoucang"></span>
                    <a href="javascript:;" class="readnum2">{{item.commnum}}</a></a
                  > -->
                  <!-- <a href="javascript:;"><i class="el-icon-star-off"></i><span>{{}}</span></a>
               -->
                  <a :href="'/video?id=' + item.id + '&uid=' + item.uid"
                    ><i class="el-icon-chat-square"></i
                    ><span class="ml">{{ item.commnum }}</span></a
                  >
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<style scoped>
.fl {
  float: left;
}
.fr {
  float: right;
}
.title {
  background-color: white;
}
.right-word {
  padding: 8px;
  text-align: center;
}
.word {
  font-size: 12px;
  color: #99a2aa;
}
.main {
  margin-top: -16px;
}
.main-cont {
  width: 980px;
  margin: 0 auto;
  margin-top: 32px;
  padding: 16px;
  background-color: white;
}
.content {
  margin: 0 auto;
  margin-top: 16px;
  width: 1012px;
}
.el-divider--horizontal {
  margin: 0px;
}
.cont-left {
  position: absolute;
  top: 24px;
  left: 24px;
}
.cont-right {
  margin-left: 60px;
}
.cont-right a {
  margin-right: 20px;
}
i {
  font-size: 24px;
  vertical-align: middle;
}
.el-col {
  margin-bottom: 16px;
  position: relative;
}
.readnum2 {
  font-size: 14px;
  margin-left: 8px;
  margin-right: 8px;
}
a:hover {
  color: #00a1d6;
}
.ml {
  margin-left: 8px;
}
.desc {
  font-size: 14px;
  color: #8a8a8a;
  width: 80%;
}
.online {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
<script>
import Header from "./headernew";
export default {
  components: {
    Header,
  },
  data() {
    return {
      activeName: "second",
      uid: 0,
      loginuid: 0,
      circleUrl:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      squareUrl:
        "https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png",
      sizeList: ["large", "medium", "small"],
      playerList: [],
      articleList: [],
      me: {},
    };
  },
  mounted() {
    let href = location.href;
    var uidstr = href.split("?")[1];
    var uid = uidstr.split("=")[1];
    var _loginuid = localStorage.getItem("loginuid");
    this.loginuid =
      _loginuid == null || _loginuid == undefined ? 0 : parseInt(_loginuid);
    this.getList(uid);
    this.getMeDetail(uid);
    this.getListArticle(1, uid);
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    dateFormat(date) {
      return date.split("T")[0];
    },
    getList(uid) {
      this.$http
        .get("/api/playerdetail/" + uid)
        .then((r) => {
          console.log(r);
          //获取角色列表
          if (r.data.code == 200) {
            this.playerList = r.data.data;
          } else {
            this.$alert("获取数据失败，请重试", "", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getListArticle(pageIndex, id) {
      this.pageIndex = pageIndex;
      this.$http
        .get("/api/articleview2/" + pageIndex + "/" + id)
        .then((r) => {
          console.log(r);
          //获取角色列表
          if (r.data.code == 200) {
            this.articleList = r.data.data;
          } else {
            this.$alert("获取数据失败，请重试", "", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    clickLikeBtn(contid) {
      //点赞功能
      if (this.loginuid == 0) {
        //未登录
        this.$alert("请先登录", "", {
          confirmButtonText: "确定",
        });
        return;
      }
      this.$http
        .post("/api/like/", { cont_id: contid, uid: this.loginuid })
        .then((r) => {
          console.log(r);
          //获取角色列表
          if (r.data.code == 200) {
            this.$alert(r.data.msg, "", {
              confirmButtonText: "确定",
            });
            for (var i = 0; i < this.playerList.length; i++) {
              if (this.playerList[i].id == contid) {
                var _likeState = this.playerList[i].likestate;
                var _likenum = this.playerList[i].likenum;
                this.playerList[i].likestate = _likeState == 0 ? 1 : 0;
                if (r.data.msg.indexOf("取消") > -1) {
                  _likenum--;
                } else {
                  _likenum++;
                }
                this.playerList[i].likenum = _likenum;
                break;
              }
            }
          } else {
            this.$alert("操作失败，请重试", "", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },

    getMeDetail(uid) {
      this.$http
        .get("/api/me?uid=" + uid)
        .then((r) => {
          console.log(r);
          //获取角色列表
          this.me = r.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>